import { LoadingContainer } from "../../../app/LoadingContainer";
import { ErrorContainer } from "../../../app/ErrorContainer";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Localized, useLocalization } from "@fluent/react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { loadProjectProcess, ProjectProcess } from "../projectProcess/ProjectProcessApiClient";
import { selectProjectProcessById } from "../projectProcess/projectProcessSlice";
import { useCallback, useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { Alert, Box, Button, Card, CardContent, CardHeader, Chip, Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Skeleton, Stack, Step, StepContent, StepLabel, Stepper, Tab, Tooltip, Typography } from "@mui/material";
import {
  Launch,
  Article,
  InsertDriveFile,
  Description
} from "@mui/icons-material";
import { ValidationProcessHeader } from "./components/ValidationProcessHeader";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { alpha } from "@mui/material/styles";
import React from "react";
import { loadValidationProcessStageOverview, ProcessDocumentOverview, ProcessStageOverview } from "./validationProcessApi";
import { MeetingMinutesList } from "../mettingMinutes/MeetingMinutesList";
import { NotesList } from "../Notes/NotesList";
import { DocumentStatusPill } from "../../documents/controls/DocumentStatusPill";
import { StageActivationRouter } from "./components/StageActivationRouter";
import { LoadDevices } from "../../../app/AppDataLoader";
import { ValidationProcessManagementPanel } from "./components/ValidationProcessManagementPanel";
import produce from "immer"
import { LocalPrintshop } from "@mui/icons-material";
import { DocumentReportPrinter } from "../../documents/components/DocumentReportPrinter";
import { Assessment } from '@mui/icons-material';
import { GenerareReportForProtocol } from "./dialogs/GenerareReportForProtocol";
import { ProcessTeamMembersPanel } from "../projectProcess/components/ProcessTeamMembersPanel";
import { AttachmentsBoard } from "./AttachmentsBoard";
import { AppId } from "../../../app/appTypes";
import { loadProcessValidatedObject, ValidatedObject } from "./validatedObjectApi"
import { DeviceGeneralInfo, DeviceHead } from "../../device/DeviceForm";
import { Device } from "../../device/deviceSlice";
import { ComputerizedSystem } from "../../computerizedSystems/computerizedSystemsApi";
import { ComputerizedSystemHead } from "../../computerizedSystems/ComputerizedSystemForm";
import { ComputerizedSystemOverviewPanel } from "../../computerizedSystems/panels/ComputerizedSystemOverviewPanel";
import { impossible } from "../../../app/Utils";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { SkipUrsStageDialog } from "./components/SkipUrsStageDialog";
import { ChangeValidatedObjectWizard } from "./dialogs/ChangeValidatedObjectWizard";
import { SkipStageDialog } from "./components/SkipStageDialog";
import { getStageMeta, stageColorKey } from "./utils/validationProcessStageUtils";
import { AddStageDocumentRouter } from "./components/AddStageDocumentRouter";
import { ProcessDocumentActionsMenu } from "./components/ProcessDocumentActionsMenu";
import { SkippedStageAlert } from "./components/SkippedStageAlert";
import { UnskipStageDialog } from "./components/UnskipStageDialog";
import { EntityBreadcrumbs, useEntityNavigation } from "../../../app/components/EntityBreadcrumbs";
import { usePackage } from "../../permissions/usePackage";

type FormTabs = "overview" | "management" | "notes" | "attachments" | "meetingMinutes" | "validated-object"


export const ValidationProcessForm = () => {
  const { id: paramId } = useParams(); const id = paramId ?? ''

  return <>
    <LoadDevices component={<Skeleton variant="rectangular" height={100} />}>
      <EditForm processId={id} />
    </LoadDevices>
  </>
}


const EditForm = (props: { processId: string }) => {
  const { processId } = props
  const { l10n } = useLocalization()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [params, setParams] = useSearchParams()
  const navigateToEntity = useEntityNavigation({ type: "process", id: processId })

  const { id: paramId } = useParams(); const id = paramId ?? ''
  const [process, setProcess] = useState<ProjectProcess>()
  const [stages, setStages] = useState<ProcessStageOverview[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [error, setError] = useState(null);
  const [changeValidatedObjectOpen, setChangeValidatedObjectOpen] = useState(false);

  const [reportDialog, setReportDialog] = React.useState<{
    open: boolean;
    stageId: string | null;
    doc: ProcessDocumentOverview | null;
  }>({ open: false, stageId: null, doc: null });

  const openReportDialog = (stageId: string, doc: ProcessDocumentOverview) =>
    setReportDialog({ open: true, stageId, doc });

  const closeReportDialog = () =>
    setReportDialog({ open: false, stageId: null, doc: null });
  const handleReportCancel = () => {
    closeReportDialog();
  };

  const handleReportSuccess = (updated: ProcessStageOverview) => {
    closeReportDialog();

    setStages(prev =>
      prev.map(s => (s.id === updated.id ? updated : s))
    );
  };
  const [stageActivation, setStageActivation] = React.useState<{ open: boolean; stage: any | null }>({
    open: false,
    stage: null,
  });

  const [stageSkip, setSkipStage] = React.useState<{ open: boolean; stage: any | null }>({
    open: false,
    stage: null,
  });


  const [ursSkipDialog, setUrsSkipDialog] = React.useState<{
    open: boolean;
    stage: ProcessStageOverview | null;
  }>({
    open: false,
    stage: null,
  });

  const handleSkipUrsStage = (stage: ProcessStageOverview) => {
    setUrsSkipDialog({ open: true, stage });
  };


  const [skipStageDialog, setSkipStageDialog] = useState<{
    open: boolean;
    stage: ProcessStageOverview | null;
  }>({ open: false, stage: null });

  const handleSkipStageClick = (stage: ProcessStageOverview) => {
    setSkipStageDialog({ open: true, stage });
  };

  const [unskipStageDialog, setUnskipStageDialog] = useState<{
    open: boolean;
    stage: ProcessStageOverview | null;
  }>({ open: false, stage: null });

  const handleUnskipStageClick = (stage: ProcessStageOverview) => {
    setUnskipStageDialog({ open: true, stage });
  };

  const isStageActive = (s: ProcessStageOverview) => {
    const st = (s.status || s.status || "").toString().toUpperCase();
    return st === "IN_PROGRESS";
  };

  const [addStageDocument, setAddStageDocument] = useState<{
    open: boolean;
    stage: ProcessStageOverview | null;
    docCode: string;
  }>({
    open: false,
    stage: null,
    docCode: "",
  });

  const openAddStageDocument = (stage: ProcessStageOverview, docCode: string) => {
    setAddStageDocument({
      open: true,
      stage: stage,
      docCode: docCode,
    });
  };

  const handleCloseAddStageDocument = () => {
    setAddStageDocument({ open: false, stage: null, docCode: "" });
  };

  const handleAddStageDocumentSuccess = (updatedStage: ProcessStageOverview) => {
    setStages(prev =>
      prev.map(s => (s.id === updatedStage.id ? updatedStage : s))
    );
    handleCloseAddStageDocument();
  };

  const handleAddRA = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "RA");
  };
  const handleAddVMP = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "VMP");
  };

  const handleAddDQ = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "DQ");
  };

  const handleAddAC = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "AC");
  };

  const handleAddIQ = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "IQ");
  };

  const handleAddOQ = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "OQ");
  };

  const handleAddACS = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "ACS");
  };

  const handleAddACM = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "ACM");
  };
  const handleAddACP = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "ACP");
  };

  const handleAddACF = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "ACF");
  };



  const handleAddPQ = (stage: ProcessStageOverview) => {
    openAddStageDocument(stage, "PQ");
  };


  const isStageSkipped = (s: ProcessStageOverview) =>
    (s.status || s.status || "").toString().toUpperCase() === "SKIPPED";

  const handleStartStage = (stage: any) => {
    setStageActivation({ open: true, stage });
  };


  const handleActivationSuccess = (updated: ProcessStageOverview) => {
    setStageActivation({ open: false, stage: null });

    setStages(prev =>
      produce(prev, draft => {
        const idx = draft.findIndex(s => s.id === updated.id);

        if (idx >= 0) {
          draft[idx] = { ...draft[idx], ...updated };
        } else {
          draft.unshift(updated);
        }
      })
    );
  };

  const [printState, setPrintState] = useState<{
    open: boolean;
    documentId: string | null;
    mode: "PRINT" | "PDF" | "PREVIEW";
    language: string;
  }>({
    open: false,
    documentId: null,
    mode: "PRINT",
    language: "PL",
  });

  const handleOpenPrint = (
    doc: ProcessDocumentOverview,
    mode: "PRINT" | "PDF" | "PREVIEW" = "PRINT",
    language?: string
  ) => {
    setPrintState({
      open: true,
      documentId: String(doc.id),
      mode,
      language: language ?? (doc as any).language ?? "PL",
    });
  };

  const handleClosePrint = () =>
    setPrintState((s) => ({ ...s, open: false }));


  const handleCloseActivation = () => {
    setStageActivation({ open: false, stage: null });
  };

  const tab = params.get('tab') as FormTabs || 'overview'
  const canSeeMeetingMinutes = usePackage("MeettingMinutes")

  const setTab = (tab: FormTabs) => {
    params.set('tab', tab)
    setParams(params, { replace: true })
  }

  const handleTabChange = useCallback((_, newTab) => {
    setTab(newTab)
  }, [])


  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const loadedProcess = await dispatch(loadProjectProcess(processId)).then(unwrapResult);
      setProcess(loadedProcess);

      const loadedStages = await dispatch(loadValidationProcessStageOverview(processId)).then(unwrapResult);
      setStages(loadedStages);
    } catch (err) {
      setIsError(true);
      setError(err as any);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, processId]);

  const handleProcessSave = useCallback(
    (updated: ProjectProcess, refreshRequired?: boolean) => {
      if (refreshRequired) {
        fetchData();
      } else {
        setProcess(
          produce<ProjectProcess>(draft => {
            Object.assign(draft, updated);
          })
        );
      }
    },
    [fetchData]
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleOpenDocument = (doc: ProcessDocumentOverview) => {
    navigateToEntity({ type: "document", id: String(doc.id), documentType: doc.type });
  };


  const hasDocOfType = (stage: ProcessStageOverview, docType: string) => {
    const wanted = (docType ?? "").toUpperCase();
    return (stage.documents ?? []).some(d => ((d.type ?? "") as string).toUpperCase() === wanted);
  };


  const formatDate = (value?: Date | string) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString(); // domyślny format przeglądarki
  };

  if (isError) {
    return <>
      <ErrorContainer error={error} />
    </>
  }

  if (isError) {
    return <>
      <ErrorContainer error={error} />
    </>
  }

  if (isLoading) {
    return <>
      <LoadingContainer />
    </>
  }


  if (process === undefined) {
    return <Skeleton animation="wave" variant="rectangular" height="64vh" ></Skeleton>;
  }

  return <>
    <Container maxWidth={false} sx={{ padding: "2px", paddingLeft: "2px!important", paddingRight: "2px!important" }}>
      <EntityBreadcrumbs current={{ type: "process", id: process.id }} />
      <ValidationProcessHeader process={process} />
      <TabContext value={tab}>
        <TabList onChange={handleTabChange}>
          <Tab
            key={0}
            value={"overview"}
            label={<Localized id="process-stage-overview">overview</Localized>} />
          <Tab
            key={1}
            value={"management"}
            label={<Localized id="process-management">Zarządzanie</Localized>} />
          <Tab
            key={2}
            value={"team"}
            label={<Localized id="process-team">Zespół</Localized>} />
          <Tab
            key={3}
            value={"attachments"}
            label={<Localized id="process-team-attachments">Załaczniki</Localized>} />
          {canSeeMeetingMinutes && <Tab
            key={4}
            value={"meetingMinutes"}
            label={<Localized id="menu-meeting-minutes">Zapiski</Localized>} />}
          <Tab
            key={5}
            value={"notes"}
            label={<Localized id="process-scratchpad">Zapiski</Localized>} />
          <Tab
            key={6}
            value={"validated-object"}
            label={<Localized id="process-validated-object">Walidowany obiekt</Localized>} />
        </TabList>
        {/* === OVERVIEW === */}
        <TabPanel value="overview">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Card variant="outlined" sx={{ mb: 2 }}>
                <CardContent>
                  <Stepper activeStep={1} orientation="vertical" nonLinear>
                    {stages.map((stage) => {
                      const isURSStage = stage.stage?.toUpperCase() === "URS";
                      const hasDocuments = stage.documents && stage.documents.length > 0;

                      const colorKey = stageColorKey(stage.stage) ?? "primary";
                      const { label, description } = getStageMeta(stage);


                      return (
                        <Step key={stage.id} expanded active={isStageActive(stage)}>
                          <StepLabel>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Typography variant="subtitle1" fontWeight={700}>
                                {label}
                              </Typography>
                            </Stack>
                            <Typography variant="body2" color="text.secondary">
                              {description}
                            </Typography>
                          </StepLabel>
                          <StepContent sx={{
                            borderLeft: 3,
                            borderLeftColor: (t) => t.palette[colorKey].main,
                            bgcolor: (t) => alpha(t.palette[colorKey].main, 0.04),
                            borderRadius: 1,
                            pl: 1.5,
                            pr: 1,
                            py: 1.5,
                          }}>
                            {isStageSkipped(stage) && (
                              <SkippedStageAlert stage={stage} />
                            )}
                            {(stage.documents?.length ?? 0) === 0 ? (
                              <Box
                                sx={(t) => ({
                                  borderRadius: 1,
                                  bgcolor: t.palette.action.hover,
                                  px: 1.5,
                                  py: 1,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 1,
                                })}
                              >
                                <InsertDriveFile fontSize="small" color="disabled" />
                                <Typography variant="body2" color="text.secondary">
                                  <Localized id="no-documents">Brak dokumentów</Localized>
                                </Typography>
                              </Box>

                            ) : (
                              <List dense>
                                {stage.documents.map((doc) => {
                                  const secondaryLine = [
                                    doc.no ? `Nr: ${doc.no}` : null,
                                    typeof doc.version === "number" ? `Wersja: ${doc.version}` : null,
                                    doc.createDate ? `Data: ${formatDate(doc.createDate)}` : null,
                                    (doc.responsibleFullName || doc.responsibleUserName)
                                      ? `Odp.: ${doc.responsibleFullName || doc.responsibleUserName}`
                                      : null,
                                  ]
                                    .filter(Boolean)
                                    .join(" • ");

                                  return (
                                    <React.Fragment key={doc.id}>
                                      <ListItem alignItems="flex-start">
                                        <ListItemIcon
                                          sx={{
                                            minWidth: 0,
                                            width: 72,
                                            mr: 1.5,
                                            mt: 0.25,
                                            display: "flex",
                                            alignItems: "flex-start",
                                            justifyContent: "center",
                                            p: 0,
                                          }}
                                        >
                                          <Stack
                                            spacing={0.25}
                                            sx={{
                                              width: "100%",
                                              alignItems: "center",
                                            }}
                                          >
                                            {/* IKONA */}
                                            {doc.documentKind === "PROTOCOL" ? (
                                              <Article fontSize="medium" />
                                            ) : doc.documentKind === "REPORT" ? (
                                              <Description fontSize="medium" />
                                            ) : (
                                              <InsertDriveFile fontSize="medium" />
                                            )}

                                            {/* TYPE */}
                                            <Typography
                                              variant="caption"
                                              fontWeight={800}
                                              sx={{ lineHeight: 1, textAlign: "center" }}
                                            >
                                              {(doc.type ?? "").toUpperCase()}
                                            </Typography>

                                            {/* KIND - mini badge */}
                                            <Box
                                              sx={(t) => ({
                                                px: 0.75,
                                                py: 0,
                                                borderRadius: 0.75,
                                                border: `1px solid ${t.palette[doc.documentKind === "PROTOCOL" ? "primary" : "info"].main
                                                  }`,
                                                color:
                                                  t.palette[doc.documentKind === "PROTOCOL" ? "primary" : "info"].main,

                                                fontSize: "0.6rem",
                                                fontWeight: 800,
                                                lineHeight: 1.2,

                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                                maxWidth: "100%",
                                              })}
                                            >
                                              {doc.documentKind}
                                            </Box>
                                          </Stack>
                                        </ListItemIcon>
                                        <ListItemText
                                          primary={
                                            <Stack direction="row" spacing={1} alignItems="center">
                                              <Typography fontWeight={600}>{doc.title}</Typography>
                                            </Stack>
                                          }
                                          secondary={
                                            <Stack spacing={0.5} sx={{ mt: 0.25 }}>
                                              <Stack direction="row" spacing={2} flexWrap="wrap">
                                                {doc.no && (
                                                  <Typography variant="body2" color="text.secondary">
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                      <Localized id="number">_number</Localized>
                                                    </Box>
                                                    :{doc.no}
                                                  </Typography>
                                                )}
                                                {typeof doc.version === "number" && (
                                                  <Typography variant="body2" color="text.secondary">
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                      <Localized id="version">_version</Localized>
                                                    </Box>
                                                    :{doc.version}
                                                  </Typography>
                                                )}
                                              </Stack>

                                              {/* Wiersz 2: Data utworzenia + Osoba odpowiedzialna */}
                                              <Stack direction="row" spacing={2} flexWrap="wrap">
                                                {doc.createDate && (
                                                  <Typography variant="body2" color="text.secondary">
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                      <Localized id="create-date">_creation-date</Localized>:
                                                    </Box>{" "}
                                                    {(() => {
                                                      const d = new Date(doc.createDate);
                                                      return isNaN(d.getTime()) ? "" : d.toLocaleDateString();
                                                    })()}
                                                  </Typography>
                                                )}
                                                {(doc.responsibleFullName || doc.responsibleUserName) && (
                                                  <Typography variant="body2" color="text.secondary">
                                                    <Box component="span" sx={{ fontWeight: 600 }}>
                                                      <Localized id="responsible">_responsible</Localized>:
                                                    </Box>{" "}
                                                    {doc.responsibleFullName || doc.responsibleUserName}
                                                  </Typography>
                                                )}
                                              </Stack>
                                            </Stack>
                                          }
                                        />

                                        {/* prawa kolumna: status + akcja */}
                                        <Box
                                          sx={{
                                            ml: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.5,
                                            flexShrink: 0,
                                            flexWrap: "wrap",
                                          }}
                                        >

                                          <DocumentStatusPill
                                            status={doc.status}
                                            size="small"

                                          />
                                          <Divider
                                            orientation="vertical"
                                            flexItem
                                            sx={{
                                              mx: 1,
                                              opacity: 1,
                                              borderColor: (t) => t.palette.common.black,
                                              borderRightWidth: 2
                                            }}
                                          />

                                          {doc?.documentKind === 'PROTOCOL' && (
                                            <Tooltip title={<Localized id="responsible">_responsible</Localized>}>
                                              <span>
                                                <Button
                                                  size="small"
                                                  variant="contained"
                                                  startIcon={<Assessment />}
                                                  onClick={() => openReportDialog(stage.id, doc)}
                                                  sx={{ flexShrink: 0, px: 1.25, minWidth: 0 }}
                                                >
                                                  <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                                                    <Localized id="generate-report">_generate-report</Localized>
                                                  </Box>
                                                </Button>
                                              </span>
                                            </Tooltip>
                                          )}
                                          <Tooltip title={<Localized id="print">_print</Localized>}>
                                            <span>
                                              <Button
                                                size="small"
                                                variant="outlined"
                                                startIcon={<LocalPrintshop />}
                                                onClick={() => handleOpenPrint(doc)}
                                                sx={{ flexShrink: 0, px: 1.25, minWidth: 0 }}
                                              >
                                                <Localized id="print">_print</Localized>
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <Tooltip title={<Localized id="go-to">_go-to</Localized>}>
                                            <span>
                                              <Button
                                                size="small"
                                                variant="outlined"
                                                startIcon={<Launch />}
                                                onClick={() => handleOpenDocument?.(doc)}
                                                sx={{ flexShrink: 0, px: 1.25, minWidth: 0 }}
                                              >
                                                <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                                                  <Localized id="open">_open</Localized>
                                                </Box>
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          {/* 
                                          TODO
                                          <ProcessDocumentActionsMenu
                                            documentId={doc.id}
                                            documentType={doc.type}
                                          /> */}
                                        </Box>

                                      </ListItem>
                                      <Divider component="li" />
                                    </React.Fragment>
                                  );
                                })}
                              </List>
                            )}
                            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                              {isURSStage ? (
                                <>
                                  {/* URS: etap pominięty → można go AKTYWOWAĆ */}
                                  {isStageSkipped(stage) && (
                                    <Button
                                      variant="contained"
                                      color="success"
                                      onClick={() => handleStartStage(stage)}
                                      size="small"
                                    >
                                      <Localized id="stage-reactivate">Aktywuj etap</Localized>
                                    </Button>
                                  )}
                                  {/* URS: aktywny */}
                                  {isStageActive(stage) && (
                                    <>
                                      {/* jeśli są dokumenty → można też „Zmień URS” */}
                                      {hasDocuments && (
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="success"
                                          onClick={() => handleStartStage(stage)}
                                        >
                                          <Localized id="stage-change-urs">Zmień URS</Localized>
                                        </Button>
                                      )}
                                      {!hasDocuments && (
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="success"
                                          onClick={() => handleStartStage(stage)}
                                        >
                                          <Localized id="stage-add-urs">Dodaj URS</Localized>
                                        </Button>
                                      )}
                                      <Button
                                        size="small"
                                        variant="outlined"
                                        color="error"
                                        onClick={() => handleSkipUrsStage(stage)}
                                      >
                                        <Localized id="stage-skip">Pomiń etap</Localized>
                                      </Button>
                                    </>
                                  )}
                                </>
                              ) : (
                                /* Pozostałe etapy */
                                <>
                                  {!isStageSkipped(stage) && (
                                    <Stack direction="row" spacing={1} flexWrap="wrap">
                                      {stage.stage?.toUpperCase() === "RA" && !hasDocOfType(stage, "RA") && (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          size="small"
                                          onClick={() => handleAddRA(stage)}
                                        >
                                          Dodaj RA
                                        </Button>
                                      )}
                                      {stage.stage?.toUpperCase() === "VMP" && !hasDocOfType(stage, "VMP") && (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          size="small"
                                          onClick={() => handleAddVMP(stage)}
                                        >
                                          Dodaj VMP
                                        </Button>
                                      )}
                                      {stage.stage?.toUpperCase() === "DQ" && !hasDocOfType(stage, "DQ") && (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          size="small"
                                          onClick={() => handleAddDQ(stage)}
                                        >
                                          Dodaj DQ
                                        </Button>
                                      )}
                                      {stage.stage?.toUpperCase() === "AC" && !hasDocOfType(stage, "AC") && (
                                        <Button
                                          variant="contained"
                                          color="success"
                                          size="small"
                                          onClick={() => handleAddAC(stage)}
                                        >
                                          Dodaj AC
                                        </Button>
                                      )}

                                      {stage.stage?.toUpperCase() === "ACS" && (
                                        <>
                                          {!hasDocOfType(stage, "ACS") && (
                                            <Button
                                              variant="contained"
                                              color="success"
                                              size="small"
                                              onClick={() => handleAddACS(stage)}
                                            >
                                              Dodaj ACS
                                            </Button>
                                          )}

                                          {!hasDocOfType(stage, "ACM") && (
                                            <Button
                                              variant="contained"
                                              color="success"
                                              size="small"
                                              onClick={() => handleAddACM(stage)}
                                            >
                                              Dodaj ACM
                                            </Button>
                                          )}

                                          {!hasDocOfType(stage, "ACP") && (
                                            <Button
                                              variant="contained"
                                              color="success"
                                              size="small"
                                              onClick={() => handleAddACP(stage)}
                                            >
                                              Dodaj ACP
                                            </Button>
                                          )}

                                          {!hasDocOfType(stage, "ACF") && (
                                            <Button
                                              variant="contained"
                                              color="success"
                                              size="small"
                                              onClick={() => handleAddACF(stage)}
                                            >
                                              Dodaj ACF
                                            </Button>
                                          )}
                                        </>
                                      )}

                                      {(stage.stage?.toUpperCase() === "VALIDATION") && (
                                        <>
                                          {!hasDocOfType(stage, "IQ") && (
                                            <Button variant="contained" color="success" size="small" onClick={() => handleAddIQ(stage)}>
                                              Dodaj IQ
                                            </Button>
                                          )}
                                          {!hasDocOfType(stage, "OQ") && (
                                            <Button variant="contained" color="success" size="small" onClick={() => handleAddOQ(stage)}>
                                              Dodaj OQ
                                            </Button>
                                          )}
                                          {!hasDocOfType(stage, "PQ") && (
                                            <Button variant="contained" color="success" size="small" onClick={() => handleAddPQ(stage)}>
                                              Dodaj PQ
                                            </Button>
                                          )}
                                        </>
                                      )}
                                    </Stack>
                                  )}

                                  {!isStageSkipped(stage) && (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      color="error"
                                      onClick={() => handleSkipStageClick(stage)}
                                    >
                                      <Localized id="stage-skip">Pomiń etap</Localized>
                                    </Button>
                                  )}
                                  {isStageSkipped(stage) && (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      color="error"
                                      onClick={() => handleUnskipStageClick(stage)}
                                    >
                                      <Localized id="stage-restore">Przywróć etap</Localized>
                                    </Button>
                                  )}
                                </>
                              )}
                            </Stack>

                          </StepContent>
                        </Step>
                      );
                    })}
                  </Stepper>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <StageActivationRouter
            open={stageActivation.open}
            stage={stageActivation.stage}
            processId={processId}
            structureId={process.structureId}
            processName={process?.name}
            processNumber={process?.no}
            deviceId={process?.deviceId}
            onSuccess={handleActivationSuccess}
            onCancel={handleCloseActivation}
          />
          <AddStageDocumentRouter
            open={addStageDocument.open}
            stage={addStageDocument.stage}
            docCode={addStageDocument.docCode}
            processId={processId}
            structureId={process.structureId}
            processName={process?.name}
            processNumber={process?.no}
            deviceId={process?.deviceId}
            onSuccess={handleAddStageDocumentSuccess}
            onCancel={handleCloseAddStageDocument}
          />
          <SkipUrsStageDialog
            open={ursSkipDialog.open}
            processId={processId}
            onClose={() => setUrsSkipDialog({ open: false, stage: null })}
            onSuccess={(updatedStage) => {
              setStages(prev =>
                prev.map(s => (s.id === updatedStage.id ? updatedStage : s))
              );
              setUrsSkipDialog({ open: false, stage: null });
            }}
          />
          {skipStageDialog.open && skipStageDialog.stage && (
            <SkipStageDialog
              processId={processId}
              stage={skipStageDialog.stage}
              onClose={() => setSkipStageDialog({ open: false, stage: null })}
              onSuccess={(updatedStage) => {
                setStages(prev =>
                  prev.map(s => (s.id === updatedStage.id ? updatedStage : s))
                );
                setSkipStageDialog({ open: false, stage: null });
              }}
            />
          )}
          {unskipStageDialog.open && unskipStageDialog.stage && (
            <UnskipStageDialog
              processId={processId}
              stage={unskipStageDialog.stage}
              onClose={() => setUnskipStageDialog({ open: false, stage: null })}
              onSuccess={(updatedStage) => {
                setStages(prev =>
                  prev.map(s => (s.id === updatedStage.id ? updatedStage : s))
                );
                setSkipStageDialog({ open: false, stage: null });
              }}
            />
          )}
          {reportDialog.open && reportDialog.stageId && reportDialog.doc?.id && (
            <GenerareReportForProtocol
              processId={processId}
              stageId={reportDialog.stageId}
              documentId={reportDialog.doc.id}
              protocolDocument={reportDialog.doc}
              onSuccessfullGenerated={handleReportSuccess}
              onCancel={handleReportCancel} />
          )}

          {printState.documentId && (
            <DocumentReportPrinter
              documentId={printState.documentId}
              language={printState.language}
              mode={"open"}
              isDialogOpen={printState.open}
              closeDialog={handleClosePrint}
            />
          )}
        </TabPanel>
        <TabPanel value="management">
          <ValidationProcessManagementPanel
            process={process}
            onSave={handleProcessSave}
          />
        </TabPanel>
        <TabPanel value="team">
          <ProcessTeamMembersPanel
            processId={process.id}
          />
        </TabPanel>
        <TabPanel value="notes">
          <NotesList
            objectId={process.guid}
            canEdit={true}
          />
        </TabPanel>
        <TabPanel value="meetingMinutes">
          <MeetingMinutesList
            objectId={process.guid}
            objectType='PROCESS'
            canEdit={true}
          />
        </TabPanel>
        <TabPanel value='attachments'>
          <AttachmentsBoard stages={stages} />
        </TabPanel>
        <TabPanel value="validated-object">
          <ValidatedObjectCard
            processId={process.id}
            onChangeObject={() => setChangeValidatedObjectOpen(true)}
          />

          <ChangeValidatedObjectWizard
            open={changeValidatedObjectOpen}
            processId={process.id}
            onClose={() => setChangeValidatedObjectOpen(false)}
            onSuccess={() => {
              setChangeValidatedObjectOpen(false);
              fetchData();
            }}
          />
        </TabPanel>

      </TabContext>
    </Container>
  </>
}

const ValidatedObjectCard = (props: {
  processId: AppId;
  onChangeObject?: () => void;
}) => {
  const { processId, onChangeObject } = props;

  const dispatch = useAppDispatch()

  const process = useAppSelector(state => selectProjectProcessById(state.projectProcess, props.processId)) ?? impossible()

  const [vo, setVo] = useState<ValidatedObject | null | undefined>(process.validatedObject)

  useEffect(() => {
    if (!process.validatedObject) {
      dispatch(loadProcessValidatedObject(props.processId))
        .then(unwrapResult)
        .then(x => setVo(x))
    }
  }, [])

  let content: React.ReactNode;
  const ValidatedDeviceCard = (props: { device: Device }) => {
    const { device } = props
    return <Stack direction='column' spacing={2}>
      <DeviceHead device={device} />
      <DeviceGeneralInfo device={device} editable={false} />
    </Stack>
  }

  const nop = () => { }

  const ValidatedComputerizedSystemCard = (props: { system: ComputerizedSystem }) => {
    const { system } = props
    return <Stack direction='column' spacing={2}>
      <ComputerizedSystemHead system={system} />
      <ComputerizedSystemOverviewPanel system={system} onUpdate={nop} onUpdated={nop} />
    </Stack>
  }

  const ValidatedRoomCard = () => {
    return <h3>Room</h3>
  }
  if (vo === undefined) {
    content = <LoadingContainer />;
  } else if (vo === null) {
    content = <Alert severity="error">Brak zdefiniowanego walidowanego obiektu.</Alert>;
  } else if (vo.type === "DEVICE") {
    content = <ValidatedDeviceCard device={vo.data} />;
  } else if (vo.type === "COMPUTERIZED_SYSTEM") {
    content = <ValidatedComputerizedSystemCard system={vo.data} />;
  } else if (vo.type === "ROOM") {
    content = <ValidatedRoomCard />;
  } else {
    content = <></>;
  }
  return (
    <Box
      sx={(t) => ({
        border: `1px solid ${t.palette.divider}`,
        borderRadius: 1,
        p: 1.5,
      })}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1.5 }}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          Walidowany obiekt
        </Typography>

        {onChangeObject && (
          <Button
            size="small"
            variant="outlined"
            onClick={onChangeObject}
          >
            Zmień walidowany obiekt
          </Button>
        )}
      </Stack>

      {content}
    </Box>
  );

};
